import styled, { StyledOptions } from '@emotion/styled';
import { CreateStyled as BaseCreateStyled } from '@emotion/styled/base';
import { addDefaultFiltering, StyledComponentType } from './defaultPropFiltering';

export const customStyled = ((
  component: React.ElementType,
  { shouldForwardProp: providedShouldForwardProp, ...options }: StyledOptions = {},
) => {
  const type: StyledComponentType = typeof component === 'string' ? 'intrinsic' : 'custom';

  // Technically this can present issues if the incoming function is a type
  // guard because emotion's types account handle the type guard, but will not
  // be aware of the additional filtering added here. However, the use cases for
  // using a type-guard are quite edge-case-y and consumers can always use
  // `excludeDefaultFiltering` to get accurate typings.
  const shouldForwardProp =
    providedShouldForwardProp && addDefaultFiltering(providedShouldForwardProp, type);

  // Obscure the call to styled so it does not get transformed by the babel
  // plugin. This function should be transparent to emotion and only serve to
  // alter the options object.
  return { original: styled }.original(
    // styled is overloaded to accept only a _specific_ type of component, not
    // a union of mixed types.
    component as React.FunctionComponent,
    {
      ...options,
      shouldForwardProp,
    },
  );
}) as BaseCreateStyled;
